import { defineComponent, openBlock, createElementBlock, createElementVNode, normalizeClass } from "vue";
const _hoisted_1 = ["innerHTML"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "BuyBoxAlertMessage",
  props: {
    message: {
      default: ""
    },
    isEAMessage: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", null, [createElementVNode("div", {
        class: normalizeClass(["buy-box-alert-message", {
          "buy-box-alert-message--early-access": _ctx.isEAMessage
        }]),
        innerHTML: _ctx.message
      }, null, 10, _hoisted_1)]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=BuyBoxAlertMessage2.mjs.map
